import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ReportVO, DateUtility, WpProviderReport, REPSTDT_GT_REPENDDT, REPSTDT_INTERVAL_REPENDDT, ServerConstantsService } from '../shared';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import * as zingchart from 'zingchart';
import { CommonUtility, DataService} from '../shared/';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';


@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  @ViewChild('headerText') headerText: ElementRef;

  reportVO: ReportVO;
  mapName = '';
  mapNameData = '';
  roleId: number;
  sharedData: any;
  butDisabled = false;
  ServerConstants: any;
  areaCode: any;
  counties: any;
  countiesMap: any;
  countyId: any;
  countyDisabled: boolean = false;
  errorEndDateField:any;
  area1 = ["Benton","Carroll","Boone","Marion","Baxter","Fayetteville","Washington 1","Washington 2","Newton","Searcy","Crawford","Franklin","Logan 1","Logan 2","Scott","Polk","Sebastian"].sort();
  area2 = ["Fulton","Izard","Randolph","Clay","Sharp","Lawrence","Greene","Jackson","Craighead","Mississippi 1","Mississippi 2","Poinsett","Cross","Crittenden","Independence"].sort();
  area3 = ["Johnson","Pope","Yell","Perry","Conway","Van Buren","Faulkner","Stone","Cleburne","White","Lonoke","Prairie","Woodruff"].sort();
  area4 = ["Sevier","Little River","Miller","Lafayette","Hempstead","Pike","Montgomery","Columbia","Nevada","Clark","Hot Spring","Garland","Saline 1","Saline 2","Dallas","Ouachita","Calhoun","Union"].sort();
  area5 = ["Grant","Jefferson 1","Jefferson 2","Cleveland","Bradley","Lincoln","Drew","Ashley","Arkansas A","Arkansas B","Desha","Chicot","Monroe 1","Monroe 2","Phillips","Lee"].sort();
  area6 = ["Pulaski - East","Pulaski - Jacksonville","Pulaski - North","Pulaski - South","Pulaski - Southwest"].sort();
  allArea = ["Benton","Carroll","Boone","Marion","Baxter","Fayetteville","Washington 1","Washington 2","Newton","Searcy","Crawford","Franklin","Logan 1","Logan 2","Scott","Polk","Sebastian","Fulton","Izard","Randolph","Clay","Sharp","Lawrence","Greene","Jackson","Craighead","Mississippi 1","Mississippi 2","Poinsett","Cross","Crittenden","Independence",
  "Johnson","Pope","Yell","Perry","Conway","Van Buren","Faulkner","Stone","Cleburne","White","Lonoke","Prairie","Woodruff","Sevier","Little River","Miller","Lafayette","Hempstead","Pike","Montgomery","Columbia","Nevada","Clark","Hot Spring","Garland","Saline 1","Saline 2","Dallas","Ouachita","Calhoun","Union",
  "Grant","Jefferson 1","Jefferson 2","Cleveland","Bradley","Lincoln","Drew","Ashley","Arkansas A","Arkansas B","Desha","Chicot","Monroe 1","Monroe 2","Phillips","Lee","Pulaski - East","Pulaski - Jacksonville","Pulaski - North","Pulaski - South","Pulaski - Southwest"].sort();
  stateData: any;
  taskSearch: ReportVO;
  reportBeginDate: any;
  user: any;
  providerId: any;
  countyArray: string[] = [];
  reportEndDate: any;
  county: any;
  taskDueDateFrom: any;
  provider: any;
  WpProviders: WpProviderReport[];
  countyList: string[];
  pdfSrc = "/assets/data/583FederalReport1.pdf"
  mapTitle = '';
  chartData = {
    'layout': '1x2',
    'graphset': [

      {
        'type': 'bar',// Specify your chart type here.
        'x':'1%',
        'plot': {
          'bar-width': '30px',
          'value-box': {
            //Displays all data values by default.
          }
        },
        'backgroundColor': '#FFFFFF',
        'title': {
          'text': 'REFERRALS',
          'font-size': 13 // Adds a title to your chart
        },
        'legend': {
          'x': '60%',
          'y': '92%'
        },
        'scale-x': {
          'label': {
            'text': 'Month'
          },
          'values': [
            'JAN',
            'FEB',
            'MAR',
            'APR',
            'MAY',
            'JUNE'
          ]
        },
        'scale-y': {
          'label': {
            'text': 'Total Number of Referrals'
          }
          }, // Creates an interactive legend
        'series': [
          { type: 'bar', text: 'TOTAL REFERRALS', values: [3, 3, 1, 1, 2, 1], 'background-color': '#AAE9B3'}

          //{ type:"line",text:"OBTAINING EMPLOYMENT",values: [[2010,10000], [2011,11000], [2012,9800], [2013,12700],[2014,9600],[2015,11100],[2016,10900],[2017,11400]],"line-color": "#DC0ED0","marker": {"background-color": "#DC0ED0"}}
        ]
      },
      {
        'type': 'ring',
        noData: {
          text: "THERE IS NO DATA TO DISPLAY",
          fontSize: 3,
          bold: true
        },
        'scale': {
          'size-factor': 0.5
        },
        'backgroundColor': '#FFFFFF',
        x: '45%',
        y: '-5%',

        'title': {
          'text': 'ENROLLMENT',
          'height': '65px',
          'font-size': 13,
          'align': 'center'
        },
'legend': {
          "visible": "false",
          'max-items': 5,
          'overflow': 'page',
          'page-on': {
            'background-color': 'red',
            'border-width': 1,
            'border-color': 'red'
          },
          'page-off': {
            'background-color': '#ffe6e6',
            'border-width': 1,
            'border-color': 'red'
          },
          'page-status': {
            'font-color': 'red',
            'font-size': 8,
            'font-family': 'Georgia',
            'background-color': '#ffe6e6',
          },
          'x': '81%',
          'y': '65%'
        },
        'plot': {
          slice: '75%',
          'value-box': {
            'placement': 'out',
            'text' : '%v',
            decimals: 0,
            'font-size': 10,
            'offset-r': '50%'},
          'tooltip': {
            'text': ' %t : %v'
          }
        },
        'series': [
          {
            'values': [
            ]
          }

        ]
      }

    ]};


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dateUtil: DateUtility,
    private http: HttpClient,
    private refTableService: ReferenceTableService,
    private commonUtil: CommonUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
  }

  ngOnInit() {
		if(this.dataService.getSharedDataObject().get("RPRDE").navigation === false){
			this.router.navigate(['/reports/report-summary']);
		}

    this.taskSearch = new ReportVO();
    this.sharedData = this.dataService.getSharedDataObject();
    this.counties = this.refTableService.getValueFromSharedDataMap('COUNTIES').map(({name})=> name);
    this.counties.shift();
    //console.log(this.refTableService.getValueFromSharedDataMap('AREA I'));
    //this.area1 = this.refTableService.getValueFromSharedDataMap('AREA I');
    this.area1 = this.refTableService.getValueFromSharedDataMap('AREA I').map(({name})=> name);
    this.area1.shift();
    //console.log(this.area1);
    this.area2 = this.refTableService.getValueFromSharedDataMap('AREA II').map(({name})=> name);
    this.area2.shift();
    this.area3 = this.refTableService.getValueFromSharedDataMap('AREA III').map(({name})=> name);
    this.area3.shift();
    this.area4 = this.refTableService.getValueFromSharedDataMap('AREA IV').map(({name})=> name);
    this.area4.shift();
    this.area5 = this.refTableService.getValueFromSharedDataMap('AREA V').map(({name})=> name);
    this.area5.shift();
    this.area6 = this.refTableService.getValueFromSharedDataMap('AREA VI').map(({name})=> name);
    this.area6.shift();
    this.allArea = this.refTableService.getValueFromSharedDataMap('COUNTIES').map(({name})=> name);
    this.allArea.shift();
    this.countyList = this.allArea;
    console.log(this.allArea);
    this.countiesMap = this.commonUtil.createMapFromList(this.counties);
    this.roleId=this.sharedData.get("roles")[0].id;

    if (this.sharedData.get('roles')[0].id == 5) {
     this.butDisabled = true;
   
     for(let i=0; i<this.sharedData.get("userCounties").length; i++){
      this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
    }
    this.taskSearch.countyArray=this.countyArray;
    this.taskSearch.user="provider";
    this.taskSearch.county="All";
    this.taskSearch.providerId=this.sharedData.get("providerId")
    }
    else if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
    {
    this.butDisabled = true;
    this.countyDisabled = true;
    for(let i=0; i<this.sharedData.get("userCounties").length; i++){
    this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
    console.log("county id is : "+this.sharedData.get("userCounties")[i].id.serviceCounty); //use i instead of 0
     }
    this.taskSearch.countyArray=this.countyArray;
    this.taskSearch.county=this.countyArray[0];
    this.taskSearch.user="countyWorker";
    }
    else if(this.sharedData.get("roles")[0].id == 2)
    {
    this.butDisabled = true;
    for(let i=0; i<this.sharedData.get("userCounties").length; i++){
    this.countyId=this.sharedData.get("userCounties")[i].id.serviceCounty
    if(this.area1.includes(this.countiesMap.get(this.countyId)))
    {
    this.taskSearch.areaCode="Area I";
     }
    if(this.area2.includes(this.countiesMap.get(this.countyId)))
    {
    this.taskSearch.areaCode="Area II";
     }
    if(this.area3.includes(this.countiesMap.get(this.countyId)))
    {
    this.taskSearch.areaCode="Area III";
     }
    if(this.area4.includes(this.countiesMap.get(this.countyId)))
    {
    this.taskSearch.areaCode="Area IV";
     }
    if(this.area5.includes(this.countiesMap.get(this.countyId)))
    {
    this.taskSearch.areaCode="Area V";
     }
    if(this.area6.indexOf(this.countiesMap.get(this.sharedData.get("userCounties")[i].id.serviceCounty)) > -1)
    {
    this.taskSearch.areaCode="Area VI";
     }
    this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
     }
     //this.countiesMap
    this.taskSearch.countyArray=this.countyArray;
      this.taskSearch.user="areaSupervisor";
    this.taskSearch.county="All"
    console.log("areaCode ------"+this.taskSearch.areaCode)
    }
    else
    {
    this.taskSearch.areaCode="All";
    this.taskSearch.user="countyUser";
    this.taskSearch.county="All";
    this.taskSearch.provider="All";
    }

this.taskSearch.reportBeginDate="default";
this.taskSearch.reportEndDate="default";
    this.load('hello');
  }
  searchTask() {
    if (this.validDates()) {
      this.taskSearch = new ReportVO();
      this.sharedData = this.dataService.getSharedDataObject();
      this.roleId = this.sharedData.get('roles')[0].id;
      if (this.sharedData.get('roles')[0].id == 5) {
        this.butDisabled = true;
        for (let i = 0; i < this.sharedData.get('userCounties').length; i++) {
          this.countyArray.push(this.sharedData.get('userCounties')[i].id.serviceCounty);
          console.log('county id is : ' + this.sharedData.get('userCounties')[i].id.serviceCounty); //use i instead of 0
        }
        this.taskSearch.countyArray = this.countyArray;
        this.taskSearch.county=this.county;
        this.taskSearch.user = 'provider';
        this.taskSearch.providerId = this.sharedData.get('providerId');
      }
    else if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
    {
    this.butDisabled = true;
    this.countyDisabled = true;
    for(let i=0; i<this.sharedData.get("userCounties").length; i++){
    this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
    console.log("county id is : "+this.sharedData.get("userCounties")[i].id.serviceCounty); //use i instead of 0
     }
    this.taskSearch.county=this.county;
    this.taskSearch.countyArray=this.countyArray;
    this.taskSearch.county=this.countyArray[0];
    this.taskSearch.user="countyWorker";
    }

    else if(this.sharedData.get("roles")[0].id == 2)
    {
    this.butDisabled = true;
    for(let i=0; i<this.sharedData.get("userCounties").length; i++){
    this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
    console.log("county id is : "+this.sharedData.get("userCounties")[i].id.serviceCounty); //use i instead of 0
     }
     //this.countiesMap
    this.taskSearch.countyArray=this.countyArray;
    this.taskSearch.user="areaSupervisor";
    this.taskSearch.county=this.county;
    }
     else
    {
    this.taskSearch.areaCode=this.areaCode;
    this.taskSearch.user="countyUser";
    this.taskSearch.provider=this.provider;
    this.taskSearch.county=this.county;
    }

      if (this.reportBeginDate != null) {
        const day = this.reportBeginDate.day;
        const month = this.reportBeginDate.month;
        const year = this.reportBeginDate.year;
        if (day < 10 && month < 10) {
          this.reportBeginDate = year + '/0' + month + '/0' + day;
        } else if (day < 10 ) {
          this.reportBeginDate = year + '/' + month + '/0' + day;
        } else if (month < 10) {
          this.reportBeginDate = year + '/0' + month + '/' + day;
        } else {
          this.reportBeginDate = year + '/' + month + '/' + day;
        }
      } else {
        this.reportBeginDate = 'default';
      }

      if (this.reportEndDate != null) {
        const day = this.reportEndDate.day;
        const month = this.reportEndDate.month;
        const year = this.reportEndDate.year;

        if (day < 10 && month < 10) {
          this.reportEndDate = year + '/0' + month + '/0' + day;
        } else if (day < 10 ) {
          this.reportEndDate = year + '/' + month + '/0' + day;
        } else if (month < 10) {
          this.reportEndDate = year + '/0' + month + '/' + day;
        } else {
          this.reportEndDate = year + '/' + month + '/' + day;
        }
      } else {
        this.reportEndDate = 'default';
      }

      this.taskSearch.reportBeginDate=this.reportBeginDate;
      this.taskSearch.reportEndDate=this.reportEndDate;
      this.load('hello');
      }
    }

  loadCounty(params) {
    this.areaCode = params;
    if (this.areaCode == 'Area I') {
      this.countyList = this.area1;
    } else if (this.areaCode == 'Area II') {
      this.countyList = this.area2;
    } else if (this.areaCode == 'Area III') {
      this.countyList = this.area3;
    } else if (this.areaCode == 'Area IV') {
      this.countyList = this.area4;
    } else if (this.areaCode == 'Area V') {
      this.countyList = this.area5;
    } else if (this.areaCode == 'Area VI') {
      this.countyList = this.area6;
    } else {
      this.countyList = this.allArea;
    }
  }
  validDates() {
    if (this.reportBeginDate !== undefined
      && this.reportBeginDate !== null
      && this.reportEndDate !== undefined
      && this.reportEndDate !== null) {
      const startDt = new Date(this.reportBeginDate.year,
        this.reportBeginDate.month - 1,
        this.reportBeginDate.day);
      const endDt = new Date(this.reportEndDate.year,
        this.reportEndDate.month - 1,
        this.reportEndDate.day);

      if (startDt > endDt) {
        this.errorEndDateField = REPSTDT_GT_REPENDDT;
        return false;
      } else {
        this.errorEndDateField = null;
      }
      startDt.setMonth(this.reportBeginDate.month + 11);
      if (endDt > startDt) {
        this.errorEndDateField = REPSTDT_INTERVAL_REPENDDT;
        return false;
      }
    }

    return true;
  }

  load(myData) {
    const value: any[] = [];

    console.log('load method' + this.taskSearch);
    this.http.post<ReportVO>(this.ServerConstants.REPORT_SERVER_API_URL + '/report/load', this.taskSearch).subscribe(
      (data: ReportVO ) => {
        // convert date to the proper format for UI
        this.reportVO = new ReportVO();
        this.reportVO = data;
        this.sharedData = this.dataService.getSharedDataObject();
        if (this.sharedData.get('roles')[0].id == 5) {
          this.butDisabled = true;
        }
        this.roleId = this.sharedData.get('roles')[0].id;
        this.reportBeginDate = this.reportVO.reportBeginDate;
        this.reportEndDate = this.reportVO.reportEndDate;
        this.provider = this.reportVO.provider;
        this.areaCode = this.reportVO.areaCode;
        this.county = this.reportVO.county;
        /*if (this.areaCode == 'All') {
          this.countyList = this.allArea;
        }*/
        if (this.reportVO.reportBeginDate != null) {
          this.reportBeginDate = this.dateUtil.convertDateFromServerForreports(this.reportVO.reportBeginDate);
          console.log('date after is ' + this.reportBeginDate);
        }

        if (this.reportVO.reportEndDate != null) {
          this.reportEndDate = this.dateUtil.convertDateFromServerForreports(this.reportVO.reportEndDate);
        }
        //this.countyList = this.reportVO.countyList;
        console.log('state list ' + this.countyList);
        this.chartData.graphset[0]['scale-x'].values = this.reportVO.activityCodeList;
        this.chartData.graphset[0].series[0].values = this.reportVO.activityCountList;
        this.WpProviders = this.reportVO.providerList;
        // console.log('REPORT INFO list ' + this.reportVO.seriesReportInfo);
        if (this.reportVO.seriesReportInfo == null) {
        this.chartData.graphset[1].series = this.reportVO.seriesReportInfo;
        this.chartData.graphset[1].legend["visible"] = "false";
        }
        else {
        this.chartData.graphset[1].series = this.reportVO.seriesReportInfo;
        this.chartData.graphset[1].legend["visible"] = "true";
        }
        this.mapName = this.reportVO.mapName;
        this.mapNameData = this.reportVO.mapNameData;
        this.mapTitle = this.reportVO.mapTitle;
        this.stateData = this.reportVO.cityVO;

      }, response => {
        console.log('POST call in error', response);
      }, () => {
        zingchart.render({
          id: 'chartDiv',
          data: this.chartData,
          height: 450,
          width: '100%'
        });
        const test1 = {                                           y: '5%',
          'backgroundColor': '#FFFFFF',
          'title': {
            'text': 'ARKANSAS NON-COMPLIANCE GRAPH',
            //"width":20,
            'height': 7,
            'offset-x': 10,
            'offset-y': 2,
            'font-size': 13
          },
          shapes: [
            {
              type: 'zingchart.maps',
              options: {
                'name': 'usa_ar',
                // items: ['BRE','PRE','PEC','TER','REV','CUB','HUD','JED','LOV','WAR'],

                style: {
                  items: {
                    'BE'  : {
                      'backgroundColor': '#BA4A00',
                      'label': {
                        'fontColor': '#17202A',
                        'text': '',
                        'fontFamily': 'Georgia',
                        'fontSize': 8
                      },
                      'hoverState': {
                        'backgroundColor': '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : Benton <br><br> Non-Compliance :4',
                        'shadow': 0
                      }
                    },
                    CR: {
                      backgroundColor: '#BA4A00',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : Carroll <br><br> Non-Compliance : 3',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    BO: {
                      backgroundColor: '#BA4A00',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : Boone <br><br> Non-Compliance : 7',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }

                    },
                    MR: {
                      backgroundColor: '#BA4A00',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : Marion <br><br> Non-Compliance : 2',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    BA: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : BAXTER <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    FU: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : FULTON <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    SH: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : SHARP <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    RA: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : RANDOLPH <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },

                    CY: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : CLAY <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    WA: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : WASHINGTON <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    MA: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : MADISON <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    NW: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : NEWTON <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    SE: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : SEARCY <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    ST: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : STONE <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    IZ: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : IZARD <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    LW: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : LAWRENCE <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    IN: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : INDEPENDENCE <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    JA: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : JACKSON <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    PO: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : POINSETT <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    CI: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : CRAIGHEAD <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    GE: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : GREENE <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    MS: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : MISSISSIPPI <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    CF: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : CRAWFORD <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    FR: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : FRANKLIN <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    JO: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : JOHNSON <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    PP: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : POPE <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    CW: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : CONWAY <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    VB: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : VAN BUREN <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    FA: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : FAULKNER <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    CB: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : CLEBURNE <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    WH: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : WHITE <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    WO: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : WOODRUFF <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    CS: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : CROSS <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    CT: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : CRITTENDEN <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    SF: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : St. Francis <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    SB: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : SEBASTIAN <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    LO: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : LOGAN <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    YE: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : YELL <br><br> Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },

                    PE: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : PERRY<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    SC: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : SCOTT<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    PU: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : PULASKI<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    LK: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : LENOKE<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    PR: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : PRAIRIE<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    MN: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : MONROE<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    LE: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : LEE<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    PH: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : PHILIPS<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    PL: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : POLK<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    MT: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : MONTGOMERY<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    GA: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : GARLAND<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    SA: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : SALINE<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    SV: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : SEVIER<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    HW: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : HOWARD<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    PI: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : PIKE<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    CL: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : CLARK<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    HS: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : HOT SPRING<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    GR: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : GRANT<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    JE: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : JEFFERSON<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    AR: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : ARKANSAS<br><br>Non-Compliance :0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    LR: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : LITTLE RIVER <br><br> Non-Compliance : 0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    HE: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : HEMPSTEAD <br><br> Non-Compliance : 0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    NE: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : NEVADA <br><br> Non-Compliance : 0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    OU: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : OUACHITA <br><br> Non-Compliance : 0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    DA: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : DALLAS <br><br> Non-Compliance : 0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    CV: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : CELEVLAND <br><br> Non-Compliance : 0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    LI: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : LINCOLN <br><br> Non-Compliance : 0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    DE: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : DESHA <br><br> Non-Compliance : 0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    CA: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : CALHOUN <br><br> Non-Compliance : 0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    BR: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : BRADLEY <br><br> Non-Compliance : 0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    DR: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : DREW <br><br> Non-Compliance : 0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    MI: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : MILLER <br><br> Non-Compliance : 0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    LA: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : LAFAYETTE <br><br> Non-Compliance : 0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    CM: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : COLUMBIA <br><br> Non-Compliance : 0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    UN: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : UNION <br><br> Non-Compliance : 0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    AS: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : ASHLEY <br><br> Non-Compliance : 0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    },
                    CH: {
                      backgroundColor: '#A9DFBF',
                      label: {
                        text: '',
                        fontColor: '#17202A',
                        fontFamily: 'Georgia',
                        fontSize: 8
                      },
                      hoverState: {
                        backgroundColor: '#E57373'
                      },
                      'tooltip': {
                        'text': 'City Name : CHICOT <br><br> Non-Compliance : 0',
                        'text-align': 'left',
                        'border-color': '#33647a',
                        'border-width': 2,
                        'shadow': 0
                      }
                    }
                  }
                }
              }
            }

          ]
        };

        test1.shapes[0].options.style.items = this.stateData;
        test1.title.text = this.mapTitle;
        test1.shapes[0].options.name = 'usa_ar';

        zingchart.loadModules(this.mapName, function(e) {
          zingchart.render({
            id: 'myChart',
            data: test1,
            height: 400,
            width: 1000
          });
        });

      });

  }

  ngAfterViewInit () {
  }

  focusing(event) {
    if (!event.shiftKey && event.keyCode === 9) {
      event.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/reports.component.ts